import {Component, OnInit, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { PagesEventService, Url } from "src/app/common";
import {MultiSelectComponent, MultiSelectModule} from '@syncfusion/ej2-angular-dropdowns';
import {TicketReportService} from '../services/ticket-report.service';
import {Browser} from '@syncfusion/ej2-base';
import {AccumulationChartAllModule, ChartAllModule, IAxisLabelRenderEventArgs} from '@syncfusion/ej2-angular-charts';
import {ITooltipRenderEventArgs} from '@syncfusion/ej2-progressbar';
import {NgIf} from '@angular/common';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {DateRangePickerAllModule} from '@syncfusion/ej2-angular-calendars';
import {TranslateModule} from '@ngx-translate/core';

declare interface Filter {
  users: string[];
  priorities: string[];
  statuses: string[];
  arts: string[];
}

@Component({
  templateUrl: '../views/ticket-report.component.html',
  standalone: true,
  imports: [
    MultiSelectModule,
    ChartAllModule,
    NgIf,
    AccumulationChartAllModule,
    ReactiveFormsModule,
    DateRangePickerAllModule,
    TranslateModule
  ],
  providers: [TicketReportService],
  styleUrls: ['../styles/report.css']
})
export class TicketReportComponent implements OnInit {
  public fields: { text: string, value: string } = {text: 'full_name', value: 'assigned_user_id'};
  public users: { id: number, name: string, image: string, occupation: string, color: string }[] = [];


  public today: Date = new Date(new Date().toDateString());
  public weekStart: Date = new Date(new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString());
  public weekEnd: Date = new Date(new Date(new Date().setDate(new Date(new Date().setDate((new Date().getDate()
    - (new Date().getDay() + 7) % 7))).getDate() + 6)).toDateString())
  ;
  public monthStart: Date = new Date(new Date(new Date().setDate(1)).toDateString());
  public monthEnd: Date = this.today;
  public lastStart: Date = new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)).toDateString());
  public lastEnd: Date = new Date(new Date().setDate(0));
  public thisYearStart: Date = new Date(2021, 0, 1);


  public lastYearStart: Date = new Date(new Date().getFullYear() - 1, 0, 1);
  public lastYearEnd: Date = new Date(new Date().getFullYear() - 1, 11, 31);

  public ticketVolumeAndAvgData: Object[] = null;
  public averageResolutionTimeAndTotalAssigneeData: Object[] = null;
  public ticketsByCategoryData: Object[] = null;
  public ticketsByArtData: Object[] = null;


  filtersForm = new FormGroup({
    users: new FormControl([]),
    priorities: new FormControl([]),
    statuses: new FormControl([]),
    arts: new FormControl([]),
    date_range: new FormControl([]),
  });
  public filters: Filter = {} as Filter;

  public primaryXAxis: Object = {
    valueType: 'Category',
    interval: 1,
    labelIntersectAction: Browser.isDevice ? 'None' : 'Trim',
    labelRotation: Browser.isDevice ? -45 : 0,
    majorGridLines: { width: 0 },
    majorTickLines: { width: 0 }
  };

  public primaryXAxisAssignee: Object = {
    valueType: 'Category',
    interval: 1,
    labelIntersectAction: Browser.isDevice ? 'None' : 'Trim',
    labelRotation:  -45,
    majorGridLines: { width: 0 },
    majorTickLines: { width: 0 }
  };

  public primaryXAxisByArt: Object = {
    valueType: 'Category',
    interval: 1,
    labelIntersectAction: Browser.isDevice ? 'None' : 'Trim',
    majorGridLines: { width: 0 },
    majorTickLines: { width: 0 }
  };

  public trendsData: Object[] = [];

  public trendsprimaryXAxis: Object = {
    valueType: 'Category', majorTickLines: {width: 0},labelRotation: -45,
    lineStyle:{ width: 1}, majorGridLines: { width : 0}, edgeLabelPlacement: 'Shift'
  };

  public trendsPrimaryYAxis: Object = {
    minimum: 0,
    maximum: 80,
    interval: 10,
    labelFormat: "{value}", title: 'Number of Tickets',
    lineStyle: { width: 0 }, majorTickLines: { width: 0 }, minorTickLines: {width: 0},
  };
  public trendsChartArea : Object = {
    border: { width : 0}
  };
  public trendsTooltip: Object = {
    enable: true,
    enableHighlight: true,
    showNearestTooltip: true
  };
  public trendsMarker: object = {
    visible: true,
    isFilled: true, height: 5, width: 5,
    shape: 'Circle'
  };


  public primaryYAxis: Object = {
    title: 'Count / Days',
    majorTickLines: { width: 0 },
    lineStyle: { width: 0 }
  };

  public primaryYAxisAssignee: Object = {
    title: 'Count / Days',
    majorTickLines: { width: 0 },
    lineStyle: { width: 0 }
  };
  public primaryYAxisByCategory: Object = {
    title: 'Number Of Tickets',
    majorTickLines: { width: 0 },
    lineStyle: { width: 0 }
  }; public primaryYAxisByArt: Object = {
    title: 'Number Of Issues',
    majorTickLines: { width: 0 },
    lineStyle: { width: 0 }
  };
  public marker: Object = { dataLabel: { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }
  public tooltip: Object = {
    enable: true,
    header: '<b>${point.x}</b>',
    format: '${series.name}: <b>${point.y}</b>',
    enableHighlight: true
  };
  public legend: Object = {
    visible: true,
    enableHighlight: true,
    shapeWidth: 9,
    shapeHeight: 9
  };
  public cornerRadius: Object = {
    topLeft: 4,
    topRight: 4
  };

  public selected_users: Record<string, any>[] = [];



  public ticketsByStatusData: any[] = [];

  public legendSettings: Object = {
    visible: false,
  };


  public dataLabel: Object = {
    visible: true,
    position: 'Outside', name: 'DataLabelMappingName',
    font: {
      fontWeight: '600'
    },
    connectorStyle: { length: '20px', type: 'Curve'},

  };

  public startAngle: number = Browser.isDevice ? 55 : 35;
  public radius: string = Browser.isDevice ? '40%' : '70%'
  public ticketsByStatusTooltip: Object = {
    enable: true,
    enableHighlight: true,
    format: '<b>${point.x}</b>: <b>${point.y}</b>',
    header:'',

  };


  @ViewChild('selectObj') public selectObj?: MultiSelectComponent;
  constructor(private pagesEventService: PagesEventService,
              private router: Router,
              public ticketReportService: TicketReportService) {
  }

  get explodeIndex(): number {
    return this.ticketsByStatusData ? this.ticketsByStatusData.length - 1 : 0;
  }

  reload(){
    this.loadPriorityStats();
    this.loadStatusCounts();
    this.loadTrendsOverTime();
    this.loadAssigneePerformance();
    this.loadTicketsByCategory();
    this.loadTicketsByArt();
  }
  ngOnInit(): void {
    this.setBreadCrumb();
    this.getAssignedUsers();
    this.loadPriorityStats();
    this.loadStatusCounts();
    this.loadTrendsOverTime();
    this.loadAssigneePerformance();
    this.loadTicketsByCategory();
    this.loadTicketsByArt();
    this.getFilters();

    this.filtersForm.valueChanges.subscribe(value => {
      const filteredValues = Object.keys(value).reduce((acc, key) => {
        if (value[key] && value[key].length > 0) {
          acc[key] = value[key];
        }
        return acc;
      }, {});

      this.getFilters(filteredValues);
      this.reload();
      // console.log(filteredValues);
    });
  }

  setBreadCrumb() {
    var array=[{ name: 'Home', routerLink: '/' },{ name: 'Tickets Report', routerLink: '/ticket/report' }];
    this.pagesEventService.setBreadcrumbByKeys(array);
  }

  // onChangeV(event: any) {
  //   const selectedIds: any = Array.isArray(this.selectObj.value) ? this.selectObj.value : [];
  //   console.log('selected', selectedIds);
  // }

  onChangeV(event: any) {
    setTimeout(() => {
      const selectedIds = Array.isArray(this.selectObj.value) ? this.selectObj.value : [];
      if (selectedIds.length === 0) {
        // console.log('No users selected');
      } else {
        // console.log('Selected users:', selectedIds);
      }
    }, 100);
  }

  getAssignedUsers() {
    this.ticketReportService.getAssignedUsers().subscribe((users) => {
      this.users = users;
      // console.log(this.users);
    });
  }

  loadPriorityStats(filter?: any): void {
    this.ticketReportService.getPriorityStats(this.filtersForm.value).subscribe({
      next: (data: any) => {
        this.ticketVolumeAndAvgData = data;
      },
      error: (err) => {
      }
    });
  }

  loadStatusCounts(): void {
    this.ticketReportService.getStatusCounts(this.filtersForm.value).subscribe({
      next: (data: any) => {
        this.ticketsByStatusData = data.map(item => ({
          status: item.status,
          ticket_count: item.ticket_count,
          DataLabelMappingName: `${item.status}: ${item.ticket_count}`
        }));

      },
      error: (err) => {
      }
    });
  }

  loadTrendsOverTime(): void {
    this.ticketReportService.getTrendsOverTime(this.filtersForm.value).subscribe({
      next: (data: any) => {
        this.trendsData = data;
      },
      error: (err) => {
      }
    });
  }
  loadAssigneePerformance(): void {
    this.ticketReportService.getAssigneePerformance(this.filtersForm.value).subscribe({
      next: (data: any) => {
        this.averageResolutionTimeAndTotalAssigneeData = data;
      },
      error: (err) => {
      }
    });
  }
  loadTicketsByCategory(): void {
    this.ticketReportService.getTicketsByCategory(this.filtersForm.value).subscribe({
      next: (data: any) => {
        this.ticketsByCategoryData = data;
      },
      error: (err) => {
      }
    });
  }

  loadTicketsByArt(): void {
    this.ticketReportService.getTicketsByArt(this.filtersForm.value).subscribe({
      next: (data: any) => {
        this.ticketsByArtData = data;
      },
      error: (err) => {
      }
    });
  }


  getFilters(values?: any) {
    // console.log(values);
    this.ticketReportService.getFilters(values).subscribe((response: Filter) => {
      if (JSON.stringify(this.filters) !== JSON.stringify(response)) {
        this.filters = response;
      }
    });
  }

  dateChanged(event: any) {
    this.filtersForm.patchValue({
      date_range: event.text
    });
  }

}
